export default __webpack_public_path__ + "static/media/bean-product.11b0c10d.png";